import Constants from 'expo-constants';

const getEnv = () => {
	return __DEV__ ? {
		deviceId: Constants.installationId.toLowerCase(),
		defaultRestServer: 'http://127.0.0.1/driverx/rest',
		couch: {
			server: 'http://127.0.0.1:5984/',
		}
	} : {
		deviceId: Constants.installationId.toLowerCase(),
		defaultRestServer: 'https://qa.sysx.co.uk/driverx/rest',
		couch: {
			server: 'https://couchdb.qa.xdp.co.uk/',
		}
	}
};

export default getEnv;